import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=3ae36ce2&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae36ce2')) {
      api.createRecord('3ae36ce2', component.options)
    } else {
      api.reload('3ae36ce2', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=3ae36ce2&", function () {
      api.rerender('3ae36ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/AppFooter.vue"
export default component.exports